import { useDispatch } from 'react-redux';
import { TThunkDispatch } from '../types/redux/thunk';

export const useAppDispatch = useDispatch.withTypes<TThunkDispatch>();
